import { render, staticRenderFns } from "./Profile-User-Email-Regist.vue?vue&type=template&id=0aa63f1b&scoped=true&"
import script from "./Profile-User-Email-Regist.vue?vue&type=script&lang=js&"
export * from "./Profile-User-Email-Regist.vue?vue&type=script&lang=js&"
import style0 from "./Profile-User-Email-Regist.vue?vue&type=style&index=0&id=0aa63f1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa63f1b",
  null
  
)

export default component.exports